import { render, staticRenderFns } from "./dimReadonly.vue?vue&type=template&id=b038c750"
import script from "./dimReadonly.vue?vue&type=script&lang=js"
export * from "./dimReadonly.vue?vue&type=script&lang=js"
import style0 from "./dimReadonly.vue?vue&type=style&index=0&id=b038c750&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports